import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavCollapseCollapsed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 12L10 17V7L15 12Z",
		fill: "currentColor"
	})
});
export default SvgNavCollapseCollapsed;
